import { CommonModule } from '@angular/common'
import { Component, DestroyRef, inject, OnInit } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { MatIconModule } from '@angular/material/icon'
import { BulkOperation } from '@database/models/bulk-operation.interface'
import { BulkProgressService } from '@database/services/bulk-progress.service'
import { Observable } from 'rxjs'

@Component({
  selector: 'app-bulk-progress-toast',
  templateUrl: './bulk-progress-toast.component.html',
  styleUrls: ['./bulk-progress-toast.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule]
})
export class BulkProgressToastComponent implements OnInit {
  operations$: Observable<BulkOperation[]>
  private readonly _destroyRef = inject(DestroyRef)

  constructor(private progressService: BulkProgressService) {}

  ngOnInit(): void {
    this.operations$ = this.progressService.operations$
    this.operations$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {})
  }

  /**
   * Hide an operation (minimize to side button)
   */
  hideOperation(batchId: string): void {
    this.progressService.hideOperation(batchId)
  }

  /**
   * Expand a hidden operation
   */
  expandOperation(batchId: string): void {
    this.progressService.expandOperation(batchId)
  }

  /**
   * Dismiss/remove a completed operation
   */
  dismissOperation(batchId: string): void {
    this.progressService.removeOperation(batchId)
  }

  /**
   * Get progress percentage for progress bar
   */
  getProgressPercentage(operation: BulkOperation): number {
    if (operation.total === 0) return 0
    return Math.round((operation.processed / operation.total) * 100)
  }

  /**
   * Get human-readable operation label
   */
  getOperationLabel(operation: string): string {
    const labels = {
      delete: 'Deleting',
      approve: 'Approving',
      decline: 'Declining',
      flag: 'Flagging',
      unflag: 'Unflagging',
      attend: 'Marking attended',
      unattend: 'Marking unattended',
      resend: 'Resending confirmations',
      revision: 'Requesting revisions',
      invite: 'Sending invitations',
      settle: 'Settling',
      resend_sms: 'Resending SMS',
      resend_invitation: 'Resending invitations'
    }
    return labels[operation] || operation
  }
}
